<div class="">
    <div class="custella-modal d-flex flex-column">
        <div class="custella-modal-header">
            <div class="custella-modal-header-text" id="title_SetWorkflowNotificationPreviewEmail">
                <span>{{translate?.setup.users.approval.sections.sec4.singular}}</span>
            </div>
            <i class="pi pi-times pt-1"  [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left"  (click)="modalRef.hide()" id="btn_SetWorkflowNotificationPreviewEmailClose"></i>
        </div>
    </div>  

    <div class="custella-modal-body">
        <div class="custella-form-container box-none m-0">
            <div class="how-it-works">
                <div class="section">
                    <div class="section-header">
                        <span class="number">1</span>
                        <h6>{{translate?.setup.users.approval.messages.settingUpApprovalRelationships}}</h6>
                    </div>
                    <p class="section-desc" *ngIf="parentType === 'requisition'">
                        {{translate?.setup.users.approval.messages.eachRelationshipConnectsLevel}}
                    </p>
                    <p class="section-desc" *ngIf="parentType === 'consignment'">
                        {{translate?.setup.users.approval.messages.eachRelationshipConnectsLevelConsignment}}
                    </p>
                </div>
                <div class="section">
                    <div class="section-header">
                        <span class="number">2</span>
                        <h6>{{translate?.setup.users.approval.messages.systemConfiguration}}</h6>
                    </div>
                    <p class="section-desc">
                        {{translate?.setup.users.approval.messages.systemConfigLetsYouDefine}}&colon;
                        <span class="flex-align-center gap-2">
                            <b>&bull;&nbsp;{{translate?.setup.users.approval.messages.approvalOrder}}&colon;</b>
                            <span class="text-14">{{translate?.setup.users.approval.messages.approvalsSpecificSequence}}</span>
                        </span>
                        <span class="flex-align-center gap-2" *ngIf="parentType === 'requisition'">
                            <b>&bull;&nbsp;{{translate?.setup.users.approval.messages.requiredApprovers}}&colon;</b>
                            <span class="text-14">{{translate?.setup.users.approval.messages.groupsProvideApproval}}</span>
                        </span>
                        <span class="flex-align-center gap-2" *ngIf="parentType === 'consignment'">
                            <b>&bull;&nbsp;{{translate?.setup.users.approval.messages.requiredApprovers}}&colon;</b>
                            <span class="text-14">{{translate?.setup.users.approval.messages.groupsProvideApprovalConsignment}}</span>
                        </span>
                    </p>
                </div>
                <div class="section">
                    <div class="section-header">
                        <span class="number">3</span>
                        <h6>{{translate?.setup.users.approval.messages.howBinsAffectApprovalFlow}}</h6>
                    </div>
                    <div class="section-desc-two">
                        {{translate?.setup.users.approval.messages.approvalsDeterminedByGroups}}:
                        <div class="box">
                            <h6>{{translate?.setup.users.approval.messages.fromBinSource}}</h6>
                            <div class="details">
                                <span class="d-block">Example: {{translate?.setup.users.approval.messages.ifFromBin}} = "New York-ER-12"</span>
                                {{translate?.setup.users.approval.messages.levelTwoInCharge}} "New York-ER-12" {{translate?.setup.users.approval.messages.willNeedToApprove}}
                            </div>
                        </div>
                        <div class="box">
                            <h6>{{translate?.setup.users.approval.messages.toBinDestination}}</h6>
                            <div class="details" *ngIf="parentType === 'requisition'">
                                {{translate?.setup.users.approval.messages.basedOnConfigurationSettings}}
                            </div>
                            <div class="details" *ngIf="parentType === 'consignment'">
                                {{translate?.setup.users.approval.messages.basedOnConfigurationSettingsDestination}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Requisition -->
                <div class="section" *ngIf="parentType === 'requisition'">
                    <div class="section-header">
                        <span class="number">4</span>
                        <h6>{{translate?.setup.users.approval.messages.howRequisitionNotesProcessed}}</h6>
                    </div>
                    <p class="section-desc">
                        {{translate?.setup.users.approval.messages.userCreatesRequisitionNote}}&colon;
                        <span class="flex-align-center gap-2">
                            <span class="text-14">1. The system identifies the source and destination bins</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">2. {{translate?.setup.users.approval.messages.determinesZoneBinsBelong}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">3. {{translate?.setup.users.approval.messages.basedOnZoneOwnership}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">4. {{translate?.setup.users.approval.messages.approvalsRoutedAccordingToOrder}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">5. {{translate?.setup.users.approval.messages.requisitionOnlyProcessAfterApprovals}}</span>
                        </span>
                    </p>
                </div>
                <!-- Consignment -->
                <div class="section" *ngIf="parentType === 'consignment'">
                    <div class="section-header">
                        <span class="number">4</span>
                        <h6>{{translate?.setup.users.approval.messages.howConsignmentNotesProcessed}}</h6>
                    </div>
                    <p class="section-desc">
                        {{translate?.setup.users.approval.messages.userCreatesConsignmentNote}}&colon;
                        <span class="flex-align-center gap-2">
                            <span class="text-14">1. The system identifies the source and destination bins</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">2. {{translate?.setup.users.approval.messages.determinesZoneBinsBelong}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">3. {{translate?.setup.users.approval.messages.basedOnZoneOwnership}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">4. {{translate?.setup.users.approval.messages.approvalsRoutedAccordingToOrder}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span class="text-14">5. {{translate?.setup.users.approval.messages.consignmentOnlyProcessAfterApprovals}}</span>
                        </span>
                    </p>
                </div>

                <div class="section">
                    <div class="section-header">
                        <span class="number">5</span>
                        <h6>{{translate?.setup.users.approval.messages.importantRules}}</h6>
                    </div>
                    <p class="section-desc">
                        <span class="flex-align-center gap-2">
                            <span clas="text-14">&bull;&nbsp;{{translate?.setup.users.approval.messages.eachGroupOnlyLvlOne}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span clas="text-14">&bull;&nbsp;{{translate?.setup.users.approval.messages.lvlOnelvlTwoNotTheSameGroup}}</span>
                        </span>
                        <span class="flex-align-center gap-2" *ngIf="parentType === 'requisition'">
                            <span clas="text-14">&bull;&nbsp;{{translate?.setup.users.approval.messages.atLeastOneApprovalIsRequired}}</span>
                        </span>
                        <span class="flex-align-center gap-2" *ngIf="parentType === 'consignment'">
                            <span clas="text-14">&bull;&nbsp;{{translate?.setup.users.approval.messages.atLeastOneApprovalIsRequiredConsignment}}</span>
                        </span>
                        <span class="flex-align-center gap-2">
                            <span clas="text-14">&bull;&nbsp;{{translate?.setup.users.approval.messages.binLocationDetermineGroupInvolved}}</span>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
